module.exports = __webpack_public_path__ + "img/smile.dd2a2c4b.svg";